{
  "customer-register-dialog": {
    "buttons": {
      "cancel": "Zrušit",
      "next": "Další"
    },
    "text": {
      "book_as_guest": "Rezervovat jako host",
      "login": "přihlaste se",
      "or": " nebo ",
      "register": "zaregistrujte",
      "to_manage": "Chcete-li spravovat všechny své rezervace a oblíbené salony, "
    }
  }
}
